// app/javascript/components/init_select2.js
import $ from 'jquery';
import 'select2';
import { select2Matcher } from '../utils/text_match';

const initSelect2 = () => {
  // Même matcher que `.searchable-select` : recherche par mots, insensible à
  // la casse, aux accents et à l'ordre des mots.
  $('.select2').select2({ matcher: select2Matcher });
};

export { initSelect2 };